<template>
    <b-modal
        id="rubric-skill-picker"
        v-model="display"
        modal-class="apprentice-default-modal"
        :title="$t('assignment.hand_in')"
        size="md"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk">
        <div class="description">
            <p v-if="!invite">
                {{
                    $t(
                        'assignment.before_you_can_submit_this_assignment_you_must_indicate_which_skills_this_assignment_applied_to',
                    )
                }}
            </p>
            <p v-else>
                {{ $t('assignment.someone_you_worked_with_has_submitted_an_assignment_to_which_a_rubric_is_linked') }}

                {{ $t('assignment.you_can_choose_for_yourself_which_skills_you_want_to_complete_a_rubric_for') }}
            </p>
            <p>{{ $t('assignment.after_choosing_you_must_complete_a_rubric_for_each_of_these_skills') }}</p>
        </div>

        <b-form-checkbox-group stacked>
            <b-form-checkbox
                class="apprentice-checkbox"
                v-model="skillIds"
                v-for="skill in skills"
                :value="skill.id"
                :key="skill.id"
                >{{ skill.name }}
            </b-form-checkbox>
        </b-form-checkbox-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-skill-tree-skill-picker-component',
    props: {
        invite: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            display: false,
            assignment: null,
            skillIds: [],
            skills: [],
        };
    },
    methods: {
        show(assignment) {
            this.assignment = assignment;
            this.skills = assignment.assignment_skill_tree.skill_tree.skills;
            this.display = true;
        },
        onOk() {
            this.alert.saving();
            this.$emit('chosen-skill-ids', this.skillIds);
            this.display = false;
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    color: $text-muted-color;
    line-height: 1.5;
    font-size: $base-font-size;
    margin-bottom: $grid-gutter-width;

    > p {
        margin: 0;
    }
}
</style>
